import { render, staticRenderFns } from "./ShortcutPanel.vue?vue&type=template&id=7a857fef"
import script from "./ShortcutPanel.vue?vue&type=script&lang=js"
export * from "./ShortcutPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports